type Props = {
    ariaHidden?: boolean;
    count: number;
};

export const NotificationCountBadge: React.FC<Props> = ({ ariaHidden = false, count }) => (
    <span
        aria-hidden={ariaHidden || undefined}
        className="flex text-11 font-bold text-white min-h-[18px] min-w-[18px] bg-red-500 rounded-full items-center justify-center"
    >
        {count}
    </span>
);
